import { useTranslation } from "react-i18next";

export default function useDistributionArgsTableColumns() {
	const { t } = useTranslation();

	return [
		{
			id: "channel",
			Header: t("channel", "Channel"),
		},
		{
			id: "action",
			Header: t("action", "Action"),
		},
		{
			id: "args",
			Header: t("args", "Args"),
			accessor: ({ args }) => {
				let obfuscatedArgs = { ...args };

				if (args.PASSWORD) {
					obfuscatedArgs.PASSWORD = "********";
				}

				return JSON.stringify(obfuscatedArgs);
			},
		},
		{
			id: "conditionalArgs",
			Header: t("conditionalArgs", "Conditional Args"),
			accessor: ({ conditionalArgs }) => {
				if (!conditionalArgs) {
					return null;
				}
				let obfuscatedArgs = { ...conditionalArgs };

				if (conditionalArgs.PASSWORD) {
					obfuscatedArgs.PASSWORD = "********";
				}
				return JSON.stringify(obfuscatedArgs);
			},
		},
	];
}
